import { AreaMap } from '../../domain/area-map';
import { mapper } from '../../tools/mapping/mapper';
import { AreaMapEntity } from '../entity';
import type { AppDB } from '../db';

export class AreaMapRepository {
    constructor(private readonly database: AppDB) {}


    async clearAreaMapById(ids: number[]) {
        await this.database.areaMaps.where('Id').anyOf(ids).toArray(async ame => {
            for (let i = 0; i < ame.length; i++) {
                if (ame && ame[i].Id !== undefined) {
                    await this.database.areaMaps.where('Id').equals(ame[i].Id!).delete();
                }
            }
        })
    }

    async getAreaMapEntityById(id: number) {
        return await this.database.areaMaps.where('Id').equals(id).first(async ame => {
            return ame;
        });
    }

    async getAreaMapById(id: number) {
        return await this.database.areaMaps.where('Id').equals(id).first(async ame => {
            const ppe = mapper.map(ame, AreaMapEntity, AreaMap);
            return ppe;
        });
    }

    async updateAreaMap(areaMapId: number, jsonContent: string, outputData: string) {

        await this.database.areaMaps.update(areaMapId, {
            JsonContent: jsonContent,
            Data: outputData
        });

        return true;
    }

    async attachAreaMapToZone(areaMap: AreaMap, zoneId: number) {
        const ppe = mapper.map(areaMap, AreaMap, AreaMapEntity);
        const ze = await this.database.getZoneEntityById(zoneId);
        const areaMapId = await this.database.areaMaps.add(ppe);
        await this.database.zones.update(zoneId, {
            AreaMapIds: ze?.AreaMapIds ? [...ze.AreaMapIds, areaMapId] : [areaMapId]
        });

        return areaMapId;
    }

    async attachAreaMapToProcess(areaMap: AreaMap, processId: number) {
        const ppe = mapper.map(areaMap, AreaMap, AreaMapEntity);
        const areaMapId = await this.database.areaMaps.add(ppe);
        await this.database.process.update(processId, {
            AreaMapId: areaMapId
        });

        return areaMapId;
    }

    async attachAreaMapToIntervention(areaMap: AreaMap, interventionId: number) {
        const ppe = mapper.map(areaMap, AreaMap, AreaMapEntity);
        const areaMapId = await this.database.areaMaps.add(ppe);
        await this.database.interventions.update(interventionId, {
            AreaMapId: areaMapId
        });

        return areaMapId;
    }

    async attachLingetteAreaMapToIntervention(areaMap: AreaMap, interventionId: number) {
        const ppe = mapper.map(areaMap, AreaMap, AreaMapEntity);
        const areaMapId = await this.database.areaMaps.add(ppe);
        const intervention = await this.database.getInterventionEntityById(interventionId);
        await this.database.interventions.update(interventionId, {
            LingetteAreaMapTerrainIds: intervention?.LingetteAreaMapTerrainIds ? [...intervention.LingetteAreaMapTerrainIds, areaMapId] : [areaMapId]
        });

        return areaMapId;
    }
}
